
import { LoadedComponent, JSDiagramMsg, canvasState_ as canvasState__2, loadedComponentOf_, SavedWaveInfo, NumberBase, CursorType, WSConfig as WSConfig_1, waveSimStepsOverflow, waveSimMultipliers } from "../Common/CommonTypes.js";
import { toArray as toArray_1, forAll, ofArray, head, append, contains as contains_1, singleton, cons, choose, map as map_1, tryFind, empty as empty_1, length, isEmpty, filter, fold } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { min, max } from "../fable_modules/fable-library-js.5.13.0/Double.js";
import { browseFolderForOpening } from "../Interface/FilesIO.js";
import { FSharpResult$2, Result_Map, Result_DefaultValue } from "../fable_modules/fable-library-js.5.13.0/Result.js";
import { CircuitCheck, Msg, Msg_$reflection, Model_$reflection, Model__get_WaveSimOrCurrentSheet, SeqNum, currentStepSimulationStep_, waveSim_, SidecarSessionState, sidecarSession_, sidecarInFlight_, stepRunTarget_, fetchedData_, fetchedStructure_, failedFetch_, currentViewport_, readOnlyBaseline_, PinnedCanvas, sheet_, Model, UserData, WaveSimModel, Constants_initialWaveformColWidth, WaveSimState, ProjectBrowserState } from "../Model/ModelType.js";
import { toString, Record, Union } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { bigint_type, record_type, string_type, bool_type, tuple_type, list_type, lambda_type, unit_type, union_type, int32_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { toArray, FSharpMap__get_Item, add, isEmpty as isEmpty_1, exists, ofList as ofList_1, toList, tryFind as tryFind_1, map, empty } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { curry2, createAtom, stringHash, equals, equalArrays, compareArrays, compare } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { ofList, contains, empty as empty_2 } from "../fable_modules/fable-library-js.5.13.0/Set.js";
import { DrawModelType_BusWireT_Model_$reflection, DrawModelType_SheetT_Msg, DrawModelType_SymbolT_Symbol, DrawModelType_BusWireT_symbol_, DrawModelType_SheetT_wire_, DrawModelType_SheetT_Model, DrawModelType_BusWireT_Model, DrawModelType_SymbolT_Model } from "../Model/DrawModelType.js";
import { DrawModelType_SheetT_Model__Model_GetCanvasState } from "../DrawBlock/Sheet.js";
import { loadedComponentIsEqual, addStateToLoadedComponents, compareCanvas } from "../Simulator/CanvasExtractor.js";
import { value as value_7, unwrap, defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { Optic_Get, Optic_Get_op_HatDot_Z146BA564, Optic_Set, Optic_Set_op_HatEquals_Z147477F8, Compose_Lens, Compose_Lens_op_GreaterMinusGreater_Z15C92E89, Optic_Map, Optic_Map_op_HatPercent_Z1462312A } from "../Common/Optics.js";
import { syncArrayText } from "../DrawBlock/SymbolUpdate.js";
import { componentOfPath, signalOfPath, pathOfComponent, pathOfSignal } from "../Common/WavePath.js";
import { concat, toFail, join, printf, toText } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { memoryWidthsInDesign as memoryWidthsInDesign_1 } from "../Common/ParameterAnalysis.js";
import { getTextEventValue, debugLevel } from "../Interface/JSHelpers.js";
import { error, dbg, warn } from "../Shared/Log.js";
import { Cmd_batch } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { input } from "../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { Option, IInputType } from "../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { preventDefault } from "../DrawBlock/PopupHelpers.js";
import { HTMLAttr, DOMAttr } from "../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { strToBigint } from "../Simulator/NumberHelpers.js";
import { expandedHeapEstimate } from "../Simulator/GraphMerger.js";
import { SimulationBudget_maxHeapBytes } from "../Simulator/SimTypes.js";
import { stepCostOfGraph, maxCyclesFor } from "../Simulator/FastSim/FastCreate.js";
import { instrumentInterval, getTimeMs } from "../Common/TimeHelpers.js";
import { validateSheetOfDesign, makeDummySimulationError, prepareSimulationMemoized } from "../Simulator/Simulator.js";
import { SimulationError, SimulationErrorType } from "../Simulator/SimGraphTypes.js";
import { hasSynchronousComponents } from "../Simulator/SynchronousUtils.js";
import { map as map_2 } from "../fable_modules/fable-library-js.5.13.0/Array.js";
import { getAbsSegments } from "../DrawBlock/BlockHelpers.js";
import { Convert_serialize } from "../Common/SimpleJson/Json.Converter.js";
import { createTypeInfo } from "../Common/SimpleJson/TypeInfo.Converter.js";

export const Constants_projectBrowserRefreshMs = 1000;

export const Constants_projectBrowserListHeight = "300px";

export const Constants_backupLifetimeHours = 48;

export const Constants_circuitCheckDelayMs = 300;

export const Constants_multipliers = waveSimMultipliers;

export const Constants_maxStepsOverflow = waveSimStepsOverflow;

/**
 * How many cycles a waveform simulation must hold beyond its last clock.
 * 
 * Zooming out samples every Nth cycle, and reading the last sample can run a multiplier past
 * LastClock - so the arrays carry a margin of one. It used to be the largest multiplier there
 * is, whatever the simulation was: a 200-cycle simulation allocated 1203 cycles of arrays, six
 * times what it could use. A multiplier bigger than LastClock samples nothing, so the margin
 * is the largest that is not, and the one in use whatever that is - the zoom menu offers the
 * current multiplier back even when the configuration has since shrunk under it.
 */
export function Constants_waveSimZoomMargin(wsModel) {
    return fold((e, e_1) => (max(e, e_1) | 0), wsModel.SamplingZoom, filter((m) => (m <= wsModel.WSConfig.LastClock), Constants_multipliers)) | 0;
}

export function Constants_waveSimRequiredArraySize(wsModel) {
    return ((wsModel.WSConfig.LastClock + Constants_maxStepsOverflow) + Constants_waveSimZoomMargin(wsModel)) | 0;
}

export const Constants_advanceChunkMs = 1000;

export const Constants_minStepArraySize = 20;

export const Constants_shortStartClock = 200;

export const Constants_bigDesignHeapShare = 0.2;

export const Constants_rendererArraySizeWhenSidecarSimulates = 2;

export const Constants_defaultWSConfig = new WSConfig_1(2000, 0, 15, 500);

export const Constants_maxWarnSimulationSize = 100000;

export const Constants_maxSimulationSize = 9999999;

export const Constants_minScrollingWindow = 200;

export const Constants_wsButtonHeight = 30;

export const Constants_wsButtonWidth = 120;

export const Constants_wsButtonFontSize = 16;

export const Constants_scrollbarBkgRepCyclesInit = 100;

/**
 * Keep a project browser selection on a row that exists. The folder can grow or shrink under it
 * between one refresh and the next, and an index past the end would leave Enter doing nothing.
 */
export function clampSelection(index, entries) {
    if (isEmpty(entries)) {
        return 0;
    }
    else {
        return max(0, min(index, length(entries) - 1)) | 0;
    }
}

/**
 * Read a folder for the project browser: what is in it, or why it cannot be shown.
 * 
 * Done here, from the update function, rather than while rendering. A popup body runs on every
 * message, so a view that read the disk would read it continuously - and the keyboard needs the
 * number of rows before it can move between them.
 */
export function readProjectBrowserFolder(folder, selected) {
    const listing = browseFolderForOpening(folder);
    return new ProjectBrowserState(folder, listing, Result_DefaultValue(0, Result_Map((entries) => (clampSelection(selected, entries) | 0), listing)));
}

/**
 * type used for CSS grids in the UI to position an item on a grid
 */
export class CSSGridPos extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["PosElement", "PosAreaSpan", "PosAreaAbsolute"];
    }
}

export function CSSGridPos_$reflection() {
    return union_type("ModelHelpers.CSSGridPos", [], CSSGridPos, () => [[["Item1", int32_type], ["Item2", int32_type]], [["startX", int32_type], ["startY", int32_type], ["spanX", int32_type], ["spanY", int32_type]], [["startX", int32_type], ["startY", int32_type], ["spanX", int32_type], ["spanY", int32_type]]]);
}

export const initWSModel = new WaveSimModel(CursorType.Default, Constants_defaultWSConfig, undefined, WaveSimState.Empty, empty({
    Compare: (x, y) => (compare(x, y) | 0),
}), empty_1(), false, 0, 0, 5, 1, 0, 0, false, NumberBase.Hex, Constants_initialWaveformColWidth, false, false, undefined, empty_1(), empty({
    Compare: (x_1, y_1) => (compareArrays(x_1, y_1) | 0),
}), empty({
    Compare: (x_2, y_2) => (compareArrays(x_2, y_2) | 0),
}), empty({
    Compare: (x_3, y_3) => (compareArrays(x_3, y_3) | 0),
}), empty_2({
    Compare: (x_4, y_4) => (compare(x_4, y_4) | 0),
}), empty({
    Compare: (x_5, y_5) => (compare(x_5, y_5) | 0),
}), empty_2({
    Compare: (x_6, y_6) => (compareArrays(x_6, y_6) | 0),
}), undefined, undefined, undefined, 0, 0, undefined, 0, Constants_scrollbarBkgRepCyclesInit, true, "", "", "", false);

/**
 * This is needed because DrawBlock cannot directly access Issie Model.
 * can be replaced when all Model is placed at start of compile order and DB
 * model is refactored
 */
export function drawBlockModelToUserData(model, userData) {
    const bwModel = model.Sheet.Wire;
    return new UserData(userData.UserAppDir, userData.LastUsedDirectory, userData.RecentProjects, bwModel.ArrowDisplay, bwModel.Type, userData.Theme);
}

/**
 * This is needed because DrawBlock cannot directly access Issie Model.
 * can be replaced when all Model is placed at start of compile order and DB
 * model is refactored
 */
export function userDataToDrawBlockModel(model) {
    let bind$0040, bind$0040_1, bind$0040_2;
    const userData = model.UserData;
    return new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, model.WaveSim, model.WaveSimSheet, model.UISheetTrail, model.Spinner, (bind$0040 = model.Sheet, new DrawModelType_SheetT_Model((bind$0040_1 = model.Sheet.Wire, new DrawModelType_BusWireT_Model((bind$0040_2 = model.Sheet.Wire.Symbol, new DrawModelType_SymbolT_Model(bind$0040_2.Symbols, bind$0040_2.CopiedSymbols, bind$0040_2.Ports, bind$0040_2.InputPortsConnected, bind$0040_2.OutputPortsConnected, userData.Theme, bind$0040_2.HintPane)), bind$0040_1.Wires, bind$0040_1.CopiedWires, bind$0040_1.SelectedSegment, bind$0040_1.LastMousePos, bind$0040_1.ErrorWires, bind$0040_1.Notifications, userData.WireType, userData.ArrowDisplay, bind$0040_1.SnapToNet)), bind$0040.PopupViewFunc, bind$0040.PopupDialogData, bind$0040.BoundingBoxes, bind$0040.LastValidBoundingBoxes, bind$0040.SelectedLabel, bind$0040.SelectedComponents, bind$0040.SelectedWires, bind$0040.NearbyComponents, bind$0040.HoveredWire, bind$0040.ErrorComponents, bind$0040.DragToSelectBox, bind$0040.ConnectPortsLine, bind$0040.TargetPortId, bind$0040.Action, bind$0040.ShowGrid, bind$0040.CursorType, bind$0040.LastCursorType, bind$0040.LastValidPos, bind$0040.LastValidSymbol, bind$0040.SymbolEdit, bind$0040.SnapSymbols, bind$0040.SnapSegments, bind$0040.Zoom, bind$0040.CanvasSize, bind$0040.TmpModel, bind$0040.ScalingTmpModel, bind$0040.UndoList, bind$0040.RedoList, bind$0040.AutomaticScrolling, bind$0040.ScreenScrollPos, bind$0040.PendingZoomCenter, bind$0040.LastMousePos, bind$0040.ScalingBoxCentrePos, bind$0040.InitMouseToScalingBoxCentre, bind$0040.ScrollingLastMousePos, bind$0040.LastMousePosForSnap, bind$0040.MouseCounter, bind$0040.CtrlKeyDown, bind$0040.SpaceKeyDown, bind$0040.PrevWireSelection, bind$0040.OfferPasteArray, bind$0040.ScalingBox, bind$0040.Compiling, bind$0040.CompilationStatus, bind$0040.CompilationJob, bind$0040.DebugState, bind$0040.DebugData, bind$0040.DebugMappings, bind$0040.DebugIsConnected, bind$0040.DebugDevice)), model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, model.CurrentProj, model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, model.CodeEditorState);
}

/**
 * The array settings of the sheet now open, where it is an array design sheet.
 * 
 * Asked by everything that has to behave differently on one: which components the catalogue
 * offers, which the placement gesture accepts, and which item the sheet's right-click menu holds.
 */
export function openSheetArrayInfo(model) {
    const option_3 = model.CurrentProj;
    if (option_3 != null) {
        const p = option_3;
        const option_1 = tryFind((ldc) => (ldc.Name === p.OpenFileName), p.LoadedComponents);
        if (option_1 != null) {
            return option_1.ArrayInfo;
        }
        else {
            return undefined;
        }
    }
    else {
        return undefined;
    }
}

/**
 * Whether a component type may only be placed on an array design sheet, and so must be refused
 * anywhere else. The four of them are the IO that says how an array sheet's copies join up; on an
 * ordinary sheet there are no copies for them to mean anything about.
 */
export function isArrayOnlyComponent(compType) {
    switch (compType.tag) {
        case 50:
        case 51:
        case 52:
        case 53:
            return true;
        default:
            return false;
    }
}

/**
 * Has the open sheet changed since it was last saved?
 * 
 * Asked freshly rather than read off Model.SavedSheetIsOutOfDate, which is only RECOMPUTED on draw
 * block messages: a change made by anything else - the Properties pane setting a sheet's array
 * settings or its parameters - leaves that flag saying what was true before it. Switching sheets
 * saves the sheet being left, and reading a stale flag there drops the change.
 * 
 * Two things count as changed, and the first is why the canvas alone will not do: a sheet is more
 * than what is drawn on it. LoadedComponentIsOutOfDate is what says the rest of it moved.
 */
export function currentSheetIsOutOfDate(model) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const prj = matchValue;
        const _arg = tryFind((lc) => (lc.Name === prj.OpenFileName), prj.LoadedComponents);
        if (_arg != null) {
            const savedComponent = _arg;
            const canv = savedComponent.CanvasState;
            const canv$0027 = DrawModelType_SheetT_Model__Model_GetCanvasState(model.Sheet);
            if (savedComponent.LoadedComponentIsOutOfDate) {
                return true;
            }
            else if (!equalArrays(canv, canv$0027)) {
                return !compareCanvas(100, canv[0], canv[1], canv$0027[0], canv$0027[1]);
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    else {
        return false;
    }
}

/**
 * The drawn symbols of `ldc` brought into line with what it says: on an ARRAY COMPONENT a join
 * draws the channel EXPRESSION it is on and an Output draws the loop variable, and neither is
 * anywhere on the canvas - a join's channel is a parameter slot of the sheet, and the loop
 * variable is in its array settings. See SymbolUpdate.syncArrayText, which is where the rule is.
 * 
 * Takes the sheet rather than reading the open one, because the caller that matters most is
 * opening a sheet: the project's idea of which sheet is open changes around that, and passing the
 * one being loaded says which is meant without depending on when.
 */
export function syncArrayTextFor(ldc, model) {
    let option_1, l_2;
    const slots = defaultArg((option_1 = ldc.LCParameterSlots, (option_1 != null) ? option_1.ParamSlots : undefined), empty({
        Compare: (x, y) => (compare(x, y) | 0),
    }));
    return Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, (l_2 = Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SheetT_wire_)(sheet_), Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_BusWireT_symbol_)(l_2)))((symModel) => syncArrayText(ldc.ArrayInfo, slots, symModel))(model);
}

/**
 * The open sheet's symbols brought into line with it. Nothing to do where no project is open, or
 * where the open sheet is not among the loaded components yet.
 */
export function syncArrayTextOfOpenSheet(model) {
    let _arg;
    const option_1 = model.CurrentProj;
    if (option_1 != null) {
        const p = option_1;
        _arg = tryFind((lc) => (lc.Name === p.OpenFileName), p.LoadedComponents);
    }
    else {
        _arg = undefined;
    }
    if (_arg == null) {
        return model;
    }
    else {
        return syncArrayTextFor(_arg, model);
    }
}

/**
 * Whether the sheet now open is a library sheet the user asked to look inside, and so must not
 * be editable.
 */
export function openSheetIsReadOnly(model) {
    const matchValue = model.CurrentProj;
    if (matchValue == null) {
        return false;
    }
    else {
        return contains(matchValue.OpenFileName, model.OpenedLibrarySheets);
    }
}

/**
 * The draw block state to hold a read-only sheet at. Taken once the sheet has settled, never
 * while it loads: loading recomputes symbol sizes, reroutes wires whose ports have moved and
 * centres the circuit, all of which are changes the pin would otherwise undo one by one until
 * the sheet never finished opening.
 */
export function pinnedCanvasOf(sheet) {
    const sym = sheet.Wire.Symbol;
    return new PinnedCanvas(sym.Symbols, sym.Ports, sym.InputPortsConnected, sym.OutputPortsConnected, sym.CopiedSymbols, sheet.Wire.Wires, sheet.Wire.CopiedWires, sheet.BoundingBoxes);
}

function pinSymbol(pinned, live) {
    return new DrawModelType_SymbolT_Symbol(pinned.Pos, live.CentrePos, live.OffsetFromBBCentre, live.InWidth0, live.InWidth1, live.InWidths, pinned.LabelBoundingBox, pinned.LabelHasDefaultPos, pinned.LabelRotation, live.Appearance, pinned.Id, pinned.Component, pinned.Annotation, pinned.Moving, live.IsClocked, pinned.STransform, pinned.ReversedInputPorts, pinned.PortMaps, pinned.HScale, pinned.VScale, pinned.MovingPort, pinned.MovingPortTarget, pinned.ArrayText);
}

/**
 * Write the pinned state back over the live draw block, so that nothing which would be saved
 * can change while a library sheet is being viewed.
 * 
 * This is the whole of read-only enforcement. It restores rather than refuses because there are
 * too many ways to edit to block them one at a time and be sure: 58 mutating cases across the
 * three draw block Msg types, half a dozen places that write model.Sheet directly through
 * Optic.map without reaching any update function, and UpdateModel, which carries an arbitrary
 * Model -> Model and cannot be inspected at all. Undoing the change afterwards catches every
 * one of those, and goes on catching messages added later. Everything the user can reach that
 * would be reverted is separately disabled, so nothing appears to work and then springs back.
 * 
 * Called after every message, so it first asks whether anything it pins was touched at all: the
 * maps are persistent, so an untouched one is still the same object and the usual case costs
 * seven reference comparisons and no allocation.
 */
export function pinSheet(pinned, sheet) {
    const wire = sheet.Wire;
    const sym = wire.Symbol;
    const same = (a, b) => (a === b);
    if ((((((((same(sym.Symbols, pinned.Symbols) && same(sym.Ports, pinned.Ports)) && same(sym.CopiedSymbols, pinned.CopiedSymbols)) && same(wire.Wires, pinned.Wires)) && same(wire.CopiedWires, pinned.CopiedWires)) && same(sheet.BoundingBoxes, pinned.BoundingBoxes)) && isEmpty(sheet.UndoList)) && isEmpty(sheet.RedoList)) && (sheet.TmpModel == null)) {
        return sheet;
    }
    else {
        return new DrawModelType_SheetT_Model(new DrawModelType_BusWireT_Model(new DrawModelType_SymbolT_Model(same(sym.Symbols, pinned.Symbols) ? pinned.Symbols : map((cId, pinnedSym) => {
            const matchValue = tryFind_1(cId, sym.Symbols);
            if (matchValue == null) {
                return pinnedSym;
            }
            else {
                return pinSymbol(pinnedSym, matchValue);
            }
        }, pinned.Symbols), pinned.CopiedSymbols, pinned.Ports, pinned.InputPortsConnected, pinned.OutputPortsConnected, sym.Theme, sym.HintPane), pinned.Wires, pinned.CopiedWires, wire.SelectedSegment, wire.LastMousePos, wire.ErrorWires, wire.Notifications, wire.Type, wire.ArrowDisplay, wire.SnapToNet), sheet.PopupViewFunc, sheet.PopupDialogData, pinned.BoundingBoxes, sheet.LastValidBoundingBoxes, sheet.SelectedLabel, sheet.SelectedComponents, sheet.SelectedWires, sheet.NearbyComponents, sheet.HoveredWire, sheet.ErrorComponents, sheet.DragToSelectBox, sheet.ConnectPortsLine, sheet.TargetPortId, sheet.Action, sheet.ShowGrid, sheet.CursorType, sheet.LastCursorType, sheet.LastValidPos, sheet.LastValidSymbol, sheet.SymbolEdit, sheet.SnapSymbols, sheet.SnapSegments, sheet.Zoom, sheet.CanvasSize, undefined, sheet.ScalingTmpModel, empty_1(), empty_1(), sheet.AutomaticScrolling, sheet.ScreenScrollPos, sheet.PendingZoomCenter, sheet.LastMousePos, sheet.ScalingBoxCentrePos, sheet.InitMouseToScalingBoxCentre, sheet.ScrollingLastMousePos, sheet.LastMousePosForSnap, sheet.MouseCounter, sheet.CtrlKeyDown, sheet.SpaceKeyDown, sheet.PrevWireSelection, sheet.OfferPasteArray, sheet.ScalingBox, sheet.Compiling, sheet.CompilationStatus, sheet.CompilationJob, sheet.DebugState, sheet.DebugData, sheet.DebugMappings, sheet.DebugIsConnected, sheet.DebugDevice);
    }
}

/**
 * pinSheet applied to the draw block of the whole model. The model is returned untouched when the
 * sheet is, so a message that changed nothing pinned allocates nothing.
 */
export function pinDrawBlock(pinned, model) {
    const sheet = pinSheet(pinned, model.Sheet);
    if (sheet === model.Sheet) {
        return model;
    }
    else {
        return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, sheet_)(sheet)(model);
    }
}

function movesWholeCircuit(msg) {
    let matchResult;
    if (msg.tag === 3) {
        if (msg.fields[0].tag === 2) {
            if (msg.fields[0].fields[0].tag === 5) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return true;
        default:
            return false;
    }
}

/**
 * Hold the draw block at its pinned state if the open sheet is being viewed read-only. Applied
 * to the result of every message.
 */
export function pinIfReadOnly(msg, model) {
    let value;
    const matchValue = model.ReadOnlyBaseline;
    if (matchValue != null) {
        if (movesWholeCircuit(msg)) {
            return ((value = pinnedCanvasOf(model.Sheet), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, readOnlyBaseline_)(value)))(model);
        }
        else {
            const pinned = matchValue;
            return pinDrawBlock(pinned, model);
        }
    }
    else {
        return model;
    }
}

export function reduce(this$) {
    return {
        Clipboard: this$.Clipboard,
        ConnsToBeHighlighted: this$.ConnsOfSelectedWavesAreHighlighted,
        CreateComponent: unwrap(this$.LastCreatedComponent),
        CurrProject: !(this$.PopupViewFunc == null),
        CurrentSelected: this$.CurrentSelected,
        DragMode: this$.DividerDragMode,
        HasUnsavedChanges: false,
        Hilighted: this$.Hilighted,
        LastSelectedIds: this$.LastSelectedIds,
        LastSimulatedCanvasState: unwrap(this$.LastSimulatedCanvasState),
        LastUsedDialogWidth: this$.LastUsedDialogWidth,
        PopupDialogData: this$.PopupDialogData,
        RightTab: this$.RightPaneTabVisible,
        SelectedComponent: unwrap(this$.SelectedComponent),
        TopMenu: this$.TopMenuOpenState,
        ViewerWidth: this$.WaveSimViewerWidth,
    };
}

export function reduceApprox(this$) {
    return {
        Clipboard: this$.Clipboard,
        CreateComponent: unwrap(this$.LastCreatedComponent),
        CurrProject: !(this$.PopupViewFunc == null),
        DragMode: this$.DividerDragMode,
        HasUnsavedChanges: false,
        LastUsedDialogWidth: this$.LastUsedDialogWidth,
        PopupDialogData: this$.PopupDialogData,
        RightTab: this$.RightPaneTabVisible,
        ViewerWidth: this$.WaveSimViewerWidth,
    };
}

export function mapFst(mapFn, model, cmd) {
    return [mapFn(model), cmd];
}

export function mapOverProject(defaultValue, model, transform) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        return transform(matchValue);
    }
    else {
        return defaultValue;
    }
}

export function getComponentIds(model) {
    return ofList(map_1((comp) => comp.Id, DrawModelType_SheetT_Model__Model_GetCanvasState(model.Sheet)[0]), {
        Compare: (x, y) => (compare(x, y) | 0),
    });
}

/**
 * Get saveable record of WaveSimModel.
 * 
 * The selection is written as label paths rather than as the ids the model holds, so that it
 * survives being read back against a design whose ids have been reallocated or whose sheets have
 * been edited - see WavePath.fs. `topSheet` is the sheet this wave sim simulates, which the paths
 * are rooted at, and `ldcs` is the design they are walked through.
 * 
 * A wave whose component the design no longer holds is dropped here rather than written as a path
 * to nothing. That can only happen if the design changed under a live wave sim, which is when the
 * selection is stale anyway.
 */
export function getSavedWaveInfo(ldcs, topSheet, wsModel) {
    return new SavedWaveInfo(choose((wi) => pathOfSignal(ldcs, topSheet, wi), wsModel.SelectedWaves), wsModel.Radix, wsModel.WaveformColumnWidth, undefined, choose((tupledArg) => {
        const ramId = tupledArg[0];
        const option_1 = pathOfComponent(ldcs, topSheet, ramId[0], ramId[1]);
        if (option_1 != null) {
            return [option_1, tupledArg[1]];
        }
        else {
            return undefined;
        }
    }, toList(wsModel.SelectedRams)), wsModel.WSConfig, undefined, undefined, undefined, undefined);
}

/**
 * Setup current WaveSimModel from saved record.
 * 
 * The inverse of getSavedWaveInfo: each saved label path is resolved against the design as loaded.
 * A path naming a component that has since been renamed or deleted resolves to nothing and its
 * wave is simply not selected - which is the whole reason the selection is saved as labels.
 * 
 * SavedWaveInfo's shape can now be changed without a legacy reader: a file this version cannot
 * parse loses its selection and keeps its sheet (Helpers.jsonStringToState).
 */
export function loadWSModelFromSavedWaveInfo(ldcs, topSheet, swInfo) {
    let option_1, option_6;
    const SelectedWaves = defaultArg((option_1 = swInfo.SelectedWaves, (option_1 != null) ? choose((path) => signalOfPath(ldcs, topSheet, path), option_1) : undefined), initWSModel.SelectedWaves);
    const Radix = defaultArg(swInfo.Radix, initWSModel.Radix);
    const WaveformColumnWidth = defaultArg(swInfo.WaveformColumnWidth, initWSModel.WaveformColumnWidth);
    const SelectedRams = defaultArg((option_6 = swInfo.SelectedFRams, (option_6 != null) ? ofList_1(choose((tupledArg) => {
        const option_4 = componentOfPath(ldcs, topSheet, tupledArg[0]);
        if (option_4 != null) {
            return [option_4, tupledArg[1]];
        }
        else {
            return undefined;
        }
    }, option_6), {
        Compare: (x, y) => (compareArrays(x, y) | 0),
    }) : undefined), initWSModel.SelectedRams);
    return new WaveSimModel(initWSModel.DefaultCursor, defaultArg(swInfo.WSConfig, initWSModel.WSConfig), initWSModel.WSConfigDialog, initWSModel.State, initWSModel.WaveDetails, SelectedWaves, initWSModel.DefaultSelectionPending, initWSModel.FetchFailedAtMs, initWSModel.StartCycle, initWSModel.ShownCycles, initWSModel.SamplingZoom, initWSModel.CursorDisplayCycle, initWSModel.CursorExactClkCycle, initWSModel.ClkCycleBoxIsEmpty, Radix, WaveformColumnWidth, initWSModel.WaveModalActive, initWSModel.RamModalActive, initWSModel.PortSelectComp, initWSModel.RamComps, SelectedRams, initWSModel.RamStartLocation, initWSModel.RamRows, initWSModel.ShowSheetDetail, initWSModel.SelectedSheetInstance, initWSModel.ShowGroupDetail, initWSModel.HoveredLabel, initWSModel.DraggedIndex, initWSModel.PrevSelectedWaves, initWSModel.ScrollbarTbWidth, initWSModel.ScrollbarTbPos, initWSModel.ScrollbarTbOffset, initWSModel.ScrollbarBkgWidth, initWSModel.ScrollbarBkgRepCycs, initWSModel.ScrollbarQueueIsEmpty, initWSModel.SheetSearchString, initWSModel.ComponentSearchString, initWSModel.PortSearchString, initWSModel.ShowOnlySelected);
}

export function spComp(comp) {
    const matchValue = comp.Type;
    if (matchValue.tag === 26) {
        return toText(printf("Custom:%s(ins=%A:outs=%A)"))(matchValue.fields[0].Name)(matchValue.fields[0].InputLabels)(matchValue.fields[0].OutputLabels);
    }
    else {
        return toText(printf("%A"))(matchValue);
    }
}

export function spConn(conn) {
    return toText(printf("Conn:%A"))(conn.Vertices);
}

export function spState(_arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const arg = map_1(spComp, _arg[0]);
    const arg_1 = map_1(spConn, _arg[1]);
    return toText(printf("Canvas<%A,%A>"))(arg)(arg_1);
}

export function spCanvas(model) {
    const tupledArg = DrawModelType_SheetT_Model__Model_GetCanvasState(model.Sheet);
    return spState(tupledArg[0], tupledArg[1]);
}

export function spComps(comps) {
    const arg = map_1(spComp, comps);
    return toText(printf("Comps%A"))(arg);
}

export function spOpt(f, thingOpt) {
    if (thingOpt != null) {
        const arg = f(value_7(thingOpt));
        return toText(printf("Some %s"))(arg);
    }
    else {
        return "None";
    }
}

export function spLdComp(ldc) {
    const arg_2 = spComps(ldc.CanvasState[0]);
    return toText(printf("LDC<%s:%A:%s>"))(ldc.Name)(ldc.TimeStamp)(arg_2);
}

export function spProj(p) {
    const arg_1 = join("\n", map_1(spLdComp, p.LoadedComponents));
    return toText(printf("PROJ||Sheet=%s\n%s||ENDP\n"))(p.OpenFileName)(arg_1);
}

export function spMess(msg) {
    return toText(printf("MSG<<%20A>>ENDM"))(msg);
}

export function tryGetLoadedComponents(model) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        return matchValue.LoadedComponents;
    }
    else {
        return empty_1();
    }
}

export function updateLdComps(name, changeFun, ldComps) {
    return map_1((ldc) => {
        if (ldc.Name === name) {
            return changeFun(ldc);
        }
        else {
            return ldc;
        }
    }, ldComps);
}

export function updateLdCompsWithCompOpt(newCompOpt, ldComps) {
    if (newCompOpt != null) {
        const newComp = newCompOpt;
        const matchValue = tryFind((ldc) => (ldc.Name === newComp.Name), ldComps);
        if (matchValue != null) {
            return updateLdComps(newComp.Name, (_arg) => newComp, ldComps);
        }
        else {
            return cons(newComp, ldComps);
        }
    }
    else {
        return ldComps;
    }
}

/**
 * The address and data widths one memory component of the open sheet has ACROSS ITS DESIGN: one
 * pair per set of parameter values the sheet is used at, never empty.
 * 
 * Contents are one map shared by every instance of the sheet, so data offered to a memory - typed
 * into the editor, or read from a .ram file it is linked to - has to fit every one of these, not
 * merely the shape the sheet happens to be drawn at. Where nothing is parameterised there is one
 * pair and this says what it always said.
 */
export function memoryWidthsInDesign(model, compId, mem) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        return memoryWidthsInDesign_1(project.LoadedComponents, project.OpenFileName, compId, mem);
    }
    else {
        return singleton([mem.AddressWidth, mem.WordWidth]);
    }
}

/**
 * returns a string option representing the current file name if file is loaded, otherwise None
 */
export function getCurrFile(model) {
    const matchValue = model.CurrentProj;
    if (matchValue == null) {
        return undefined;
    }
    else {
        return matchValue.OpenFileName;
    }
}

export function getCurrSheets(model) {
    const matchValue = model.CurrentProj;
    if (matchValue == null) {
        return undefined;
    }
    else {
        return map_1((lc) => lc.Name, matchValue.LoadedComponents);
    }
}

function releaseWaveSimData(ws) {
    let matchValue;
    const WaveDetails = empty({
        Compare: (x, y) => (compare(x, y) | 0),
    });
    return new WaveSimModel(ws.DefaultCursor, ws.WSConfig, ws.WSConfigDialog, (matchValue = ws.State, (matchValue.tag === 5) ? WaveSimState.Ended : ((matchValue.tag === 4) ? WaveSimState.Ended : matchValue)), WaveDetails, ws.SelectedWaves, ws.DefaultSelectionPending, ws.FetchFailedAtMs, ws.StartCycle, ws.ShownCycles, ws.SamplingZoom, ws.CursorDisplayCycle, ws.CursorExactClkCycle, ws.ClkCycleBoxIsEmpty, ws.Radix, ws.WaveformColumnWidth, ws.WaveModalActive, ws.RamModalActive, ws.PortSelectComp, ws.RamComps, ws.SelectedRams, ws.RamStartLocation, ws.RamRows, ws.ShowSheetDetail, ws.SelectedSheetInstance, ws.ShowGroupDetail, ws.HoveredLabel, ws.DraggedIndex, ws.PrevSelectedWaves, ws.ScrollbarTbWidth, ws.ScrollbarTbPos, ws.ScrollbarTbOffset, ws.ScrollbarBkgWidth, ws.ScrollbarBkgRepCycs, ws.ScrollbarQueueIsEmpty, ws.SheetSearchString, ws.ComponentSearchString, ws.PortSearchString, ws.ShowOnlySelected);
}

/**
 * Everything the model believes about the .NET simulator's session, forgotten together.
 * 
 * These fields are one fact between them - there is a session, this is how far it has run, this is
 * what has been asked of it and what the last completed fetch was for - and a path that drops some
 * of them leaves the rest describing a simulation that is not there. That is not hypothetical: the
 * End Simulation button released the port slices and left the session behind, so the model went on
 * naming a build whose slices it no longer had, with `FetchedData` still claiming the caches were
 * serving it.
 * 
 * Ending a simulation is the only thing that does this. Nothing is told to the SIDECAR: it drops
 * its own session when the first sheet of the next design arrives, which is what makes a design
 * upload safe (docs/dev/sidecarInvariants.md, section E).
 */
export function forgetSidecarSession(model) {
    let value_1;
    return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, currentViewport_)(undefined)(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, failedFetch_)(undefined)(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, fetchedStructure_)(undefined)(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, fetchedData_)(undefined)(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, stepRunTarget_)(undefined)(((value_1 = empty({
        Compare: (x, y) => (compare(x, y) | 0),
    }), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, sidecarInFlight_)(value_1)))(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, sidecarSession_)(SidecarSessionState.NoSession)(model)))))));
}

/**
 * For reasons of space efficiency, ensure that no non-empty unused FastSimulation records are kept.
 * A FastSimulation holds a step array per net and a SimulationGraph node per component instance, so a
 * large design's is hundreds of MB: one left behind slows every later edit, because each major GC must
 * trace all of it. Call this before building a new simulation.
 * 
 * CurrentStepSimulationStep is the only field of the model holding one. Every WaveSim entry is
 * released as well - see releaseWaveSimData - which covers the sheet the caller is about to
 * resimulate (its WaveDetails is rebuilt by the refresh), the sheets left behind by switching the
 * waveform simulator between sheets, and the entry EndWaveSim is about to mark Ended. The truth
 * table's TableSimData is deliberately left alone: it is what regenerates the table when a
 * constraint changes, so it is in use rather than stale.
 */
export function removeAllSimulationsFromModel(model) {
    return Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, waveSim_)((table) => map((_arg, ws) => releaseWaveSimData(ws), table))(forgetSidecarSession(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, currentStepSimulationStep_)(undefined)(model)));
}

let nextSeq = 0;

export function newSeq() {
    nextSeq = (nextSeq + 1);
    return new SeqNum(nextSeq);
}

/**
 * Whether a build of the design on the .NET simulator is running.
 * 
 * Read off the in-flight table rather than kept beside it, so there is one thing that says so.
 * An answer arriving removes the entry, which is the same moment the session appears - there is
 * no window in which both are true, and none in which neither is.
 */
export function sidecarIsBuilding(model) {
    return exists((_arg, op) => {
        if (op.tag === 0) {
            return true;
        }
        else {
            return false;
        }
    }, model.SidecarInFlight);
}

/**
 * Whether a run chunk is in flight - the loop that advances the .NET simulation, which shows
 * its own progress and must suppress the stale-waveform warning while it does.
 */
export function sidecarIsRunning(model) {
    return exists((_arg, op) => {
        if (op.tag === 1) {
            return true;
        }
        else {
            return false;
        }
    }, model.SidecarInFlight);
}

/**
 * Whether a fetch of waveform data is running.
 * 
 * Read off the in-flight table, like everything else about what the simulator is doing. It was a
 * bool on the WaveSimModel, set where the fetch started and cleared where it landed - a second
 * place saying what the table says, which could disagree with it and which nothing outside the
 * waveform simulator could see.
 */
export function sidecarFetchInFlight(model) {
    return exists((_arg, op) => {
        if (op.tag === 2) {
            return true;
        }
        else {
            return false;
        }
    }, model.SidecarInFlight);
}

/**
 * Whether anything at all has been asked of the .NET simulator and not yet answered - which is
 * exactly when a SYNCHRONOUS operation may not be issued. Nothing else has to be checked: two
 * synchronous operations cannot overlap, since one runs to completion before anything else runs.
 */
export function sidecarIsBusy(model) {
    return !isEmpty_1(model.SidecarInFlight);
}

/**
 * Which simulator a button is about to start, or is running, for its label - development builds
 * only, where it is the empty string.
 * 
 * The two backends are meant to be indistinguishable, and are checked against each other for
 * exactly that. The cost is that when they are NOT - a difference in a waveform, a simulation that
 * is slow, a fetch that fails - nothing on screen says which one is being looked at, and the
 * Development menu that switches them does not say either. The button that starts a simulation is
 * where the question is asked, so it is where the answer goes.
 */
export function simulatorLabel(model) {
    if (debugLevel() > 0) {
        if (model.SimulateInRenderer) {
            return " (renderer)";
        }
        else {
            return " (.NET)";
        }
    }
    else {
        return "";
    }
}

/**
 * True if a step simulation, truth table or waveform simulation is currently open.
 * Parameters create dependencies across a whole design, so they cannot be changed while one is open.
 */
export function simulationIsOpen(model) {
    if (!equals(model.CurrentStepSimulationStep, undefined) ? true : !equals(model.CurrentTruthTable, undefined)) {
        return true;
    }
    else if (!equals(model.WaveSimSheet, undefined)) {
        return !equals(model.WaveSimSheet, "");
    }
    else {
        return false;
    }
}

/**
 * Get the current WaveSimModel used by the Model (index the map using the current wavesim sheet).
 * If no WaveSimModel for that sheet, return an empty wave sim model.
 */
export function getWSModel(model_mut) {
    getWSModel:
    while (true) {
        const model = model_mut;
        const matchValue = model.WaveSimSheet;
        if (matchValue == null) {
            const matchValue_1 = getCurrFile(model);
            if (matchValue_1 != null) {
                model_mut = (new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, model.WaveSim, matchValue_1, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, model.CurrentProj, model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, model.CodeEditorState));
                continue getWSModel;
            }
            else {
                return initWSModel;
            }
        }
        else {
            const _arg = tryFind_1(matchValue, model.WaveSim);
            if (_arg == null) {
                return initWSModel;
            }
            else {
                return _arg;
            }
        }
        break;
    }
}

/**
 * Set WaveSimModel of current sheet.
 */
export function setWSModel(wsModel, model) {
    const matchValue = getCurrSheets(model);
    const matchValue_1 = Model__get_WaveSimOrCurrentSheet(model);
    if (matchValue == null) {
        warn("cannot set the waveform simulator model for the current sheet: the project is closed");
        return model;
    }
    else if (contains_1(matchValue_1, matchValue, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    })) {
        const sheets_1 = matchValue;
        return new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, add(matchValue_1, wsModel, model.WaveSim), model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, model.CurrentProj, model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, model.CodeEditorState);
    }
    else {
        const sheets_2 = matchValue;
        return toFail(`What? can't find ${matchValue_1} in ${sheets_2} to set WSModel`);
    }
}

export const waveSimModel_ = [(m_1) => {
    const matchValue = tryFind_1(Model__get_WaveSimOrCurrentSheet(m_1), m_1.WaveSim);
    if (matchValue == null) {
        return initWSModel;
    }
    else {
        return matchValue;
    }
}, (wsr) => ((m) => (new Model(m.WindowWidth, m.KeyFocusPane, m.RunAfterRenderWithSpinner, m.UserData, add(Model__get_WaveSimOrCurrentSheet(m), wsr, m.WaveSim), m.WaveSimSheet, m.UISheetTrail, m.Spinner, m.Sheet, m.IsLoading, m.LastChangeCheckTime, m.LastSimulatedCanvasState, m.LastDetailedSavedState, m.CurrentSelected, m.LastSelectedIds, m.LastUsedDialogWidth, m.SelectedComponent, m.CurrentStepSimulationStep, m.CurrentTruthTable, m.TTConfig, m.RightPaneTabVisible, m.SimSubTabVisible, m.CircuitCheck, m.Hilighted, m.Clipboard, m.LastCreatedComponent, m.SavedSheetIsOutOfDate, m.PendingDragAddition, m.DragPlacement, m.ProjectBrowser, m.TopSheetChoiceDeclined, m.ComponentLibraries, m.OpenLibrary, m.CatalogueSearch, m.ArrayCopiesTyped, m.SimulateInRenderer, m.SidecarSession, m.ProbeRead, m.SidecarInFlight, m.SidecarBuildEndedMs, m.SidecarRunEndedMs, m.StepRunTarget, m.FetchedData, m.FetchedStructure, m.FailedFetch, m.StimulusGeneration, m.CurrentViewport, m.ViewportChangedAtMs, m.WaveScrollSettling, m.WaveScrollSerial, m.ShowLibrarySheets, m.SuppressErrorPopups, m.OpenedLibrarySheets, m.ReadOnlyBaseline, m.CurrentProj, m.PopupViewFunc, m.SpinnerPayload, m.PopupDialogData, m.Notifications, m.TopMenuOpenState, m.SheetMenuPinned, m.DividerDragMode, m.WaveSimViewerWidth, m.ConnsOfSelectedWavesAreHighlighted, m.Pending, m.UIState, m.BuildVisible, m.CodeEditorState)))];

/**
 * Update WaveSimModel of current sheet.
 */
export function updateWSModel(updateFn, model) {
    const matchValue = getCurrSheets(model);
    const matchValue_1 = Model__get_WaveSimOrCurrentSheet(model);
    if (matchValue == null) {
        warn("cannot set the waveform simulator model for the current sheet: the project is closed");
        return model;
    }
    else if (contains_1(matchValue_1, matchValue, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    })) {
        const sheets_1 = matchValue;
        return new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, add(matchValue_1, updateFn(FSharpMap__get_Item(model.WaveSim, matchValue_1)), model.WaveSim), model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, model.CurrentProj, model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, model.CodeEditorState);
    }
    else {
        const sheets_2 = matchValue;
        return toFail(`What? can't find ${matchValue_1} in ${sheets_2} to set WSModel`);
    }
}

/**
 * Update WaveSimModel of given sheet - if it does not exist do nothing
 */
export function updateWSModelOfSheet(sheet, updateFn, model) {
    const matchValue = getCurrSheets(model);
    if (matchValue == null) {
        warn("cannot set the waveform simulator model for the current sheet: the project is closed");
        return model;
    }
    else if (contains_1(sheet, matchValue, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    })) {
        const sheets_1 = matchValue;
        return new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, add(sheet, updateFn(FSharpMap__get_Item(model.WaveSim, sheet)), model.WaveSim), model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, model.CurrentProj, model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, model.CodeEditorState);
    }
    else {
        const sheets_2 = matchValue;
        warn(`cannot set the waveform simulator model for '${sheet}': it is not one of ${sheets_2}`);
        return model;
    }
}

/**
 * a long function to be executed in a message after the view function has run at least once
 */
export class ViewableJob extends Record {
    constructor(JobWork, ViewHasExecuted, JobName) {
        super();
        this.JobWork = JobWork;
        this.ViewHasExecuted = ViewHasExecuted;
        this.JobName = JobName;
    }
}

export function ViewableJob_$reflection() {
    return record_type("ModelHelpers.ViewableJob", [], ViewableJob, () => [["JobWork", lambda_type(Model_$reflection(), tuple_type(Model_$reflection(), list_type(lambda_type(lambda_type(Msg_$reflection(), unit_type), unit_type))))], ["ViewHasExecuted", bool_type], ["JobName", string_type]]);
}

export let asyncJobs = createAtom(empty_1());

export function runAfterView(jobName, workFn) {
    const job = new ViewableJob(workFn, false, jobName);
    dbg(1, concat("scheduling deferred job ", jobName));
    asyncJobs(append(asyncJobs(), singleton(job)));
}

export function setAsyncJobsRunnable(dispatch) {
    dispatch(Msg.DoNothing);
    asyncJobs(map_1((job) => (new ViewableJob(job.JobWork, true, job.JobName)), asyncJobs()));
}

/**
 * called from update function, it will execute outstanding async jobs.
 * each job modifies model.
 */
export function execOneAsyncJobIfPossible(model, cmd) {
    const _arg = filter((job) => job.ViewHasExecuted, asyncJobs());
    if (!isEmpty(_arg)) {
        const job_1 = head(_arg);
        asyncJobs(filter((job$0027) => (job$0027.JobName !== job_1.JobName), asyncJobs()));
        const tupledArg = job_1.JobWork(model);
        return [tupledArg[0], Cmd_batch(ofArray([cmd, tupledArg[1]]))];
    }
    else {
        return [model, cmd];
    }
}

/**
 * Return the project with with open file contents in loadedcomponents updated according to
 * current Draw Block contents.
 */
export function getUpdatedLoadedComponents(project, model) {
    return mapOverProject(project, model, (p) => {
        let optic, l, value;
        return ((optic = ((l = loadedComponentOf_(p.OpenFileName), Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, canvasState__2)(l))), (value = DrawModelType_SheetT_Model__Model_GetCanvasState(model.Sheet), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, optic)(value))))(p);
    });
}

/**
 * Set the part of model specified by optic_ to initToSet: bounded by maxVal, minVal.
 * dispatch: the Elmihs dispatch function.
 */
export function setModelInt(optic__, optic___1, dispatch, maxVal, minVal, intToSet) {
    const optic_ = [optic__, curry2(optic___1)];
    const intToSet_1 = ((intToSet > maxVal) ? maxVal : ((intToSet < minVal) ? minVal : intToSet)) | 0;
    dispatch(new Msg(/* UpdateModel */ 41, [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, optic_)(intToSet_1)]));
}

/**
 * Both input text and its parsed numeric value must be stored in the model.
 * The two fields contain optics used to access these items in the model
 */
export class ModelLocations extends Record {
    constructor(TextOptic_, ValOptic_) {
        super();
        this.TextOptic_ = TextOptic_;
        this.ValOptic_ = ValOptic_;
    }
}

export function ModelLocations_$reflection() {
    return record_type("ModelHelpers.ModelLocations", [], ModelLocations, () => [["TextOptic_", tuple_type(lambda_type(Model_$reflection(), string_type), lambda_type(string_type, lambda_type(Model_$reflection(), Model_$reflection())))], ["ValOptic_", tuple_type(lambda_type(Model_$reflection(), bigint_type), lambda_type(bigint_type, lambda_type(Model_$reflection(), Model_$reflection())))]]);
}

/**
 * Display an input box which is parsed as a bigint and written back to the Model using
 * textOptic (the text) and valOptic (the value). isValid must return true for the value to be written back to
 * the model
 */
export function inputBigint(props, placeholder, locs, isValid, dispatch, model) {
    return input(ofArray([new Option(/* Type */ 1, [IInputType.Text$]), new Option(/* Props */ 15, [append(ofArray([new DOMAttr(/* OnPaste */ 2, [(e) => {
        preventDefault(e);
    }]), new HTMLAttr(/* AutoFocus */ 55, [true]), new HTMLAttr(/* SpellCheck */ 148, [false])]), props)]), new Option(/* Placeholder */ 12, [placeholder]), new Option(/* DefaultValue */ 10, [Optic_Get_op_HatDot_Z146BA564(Optic_Get.Get, locs.TextOptic_)(model)]), new Option(/* OnChange */ 13, [(arg_5) => {
        let bigNum;
        const text = getTextEventValue(arg_5);
        dispatch(new Msg(/* UpdateModel */ 41, [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, locs.TextOptic_)(text)]));
        const matchValue = strToBigint(text);
        let matchResult;
        if (matchValue.tag === 0) {
            if ((bigNum = matchValue.fields[0], isValid(bigNum, Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, locs.ValOptic_)(bigNum)(model)))) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                dispatch(new Msg(/* UpdateModel */ 41, [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, locs.ValOptic_)(matchValue.fields[0])]));
                break;
            }
            case 1: {
                break;
            }
        }
    }])]));
}

export function simReset(dispatch) {
    dispatch(Msg.CloseSimulationNotification);
    dispatch(Msg.ClosePropertiesNotification);
    dispatch(new Msg(/* Sheet */ 3, [DrawModelType_SheetT_Msg.ResetSelection]));
    dispatch(new Msg(/* JSDiagramMsg */ 8, [new JSDiagramMsg(/* InferWidths */ 3, [undefined])]));
}

/**
 * Start simulating the current Diagram.
 * Return SimulationData that can be used to extend the simulation
 * as needed, or error if simulation fails.
 * Note that simulation is only redone if current canvas changes.
 * What the design a simulation of this sheet would expand to costs in heap, worked out the way
 * GraphMerger refuses on and from the same pair of canvas and project the simulation itself is
 * assembled from.
 */
export function simulationHeapEstimate(simulatedSheet, openSheetCanvasState_, openSheetCanvasState__1, model) {
    let option_1, tupledArg;
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        const simSheet = defaultArg(simulatedSheet, project.OpenFileName);
        const ldcs = map_1((ldc) => {
            if (ldc.Name === project.OpenFileName) {
                return new LoadedComponent(ldc.Name, ldc.TimeStamp, ldc.FilePath, ldc.WaveInfo, [openSheetCanvasState_, openSheetCanvasState__1], ldc.InputLabels, ldc.OutputLabels, ldc.LCParameterSlots, ldc.Form, ldc.LoadedComponentIsOutOfDate, ldc.Description, ldc.IsTopSheet, ldc.ArrayInfo);
            }
            else {
                return ldc;
            }
        }, project.LoadedComponents);
        return defaultArg((option_1 = tryFind((ldc_1) => (ldc_1.Name === simSheet), ldcs), (option_1 != null) ? ((tupledArg = option_1.CanvasState, expandedHeapEstimate(simSheet, tupledArg[0], tupledArg[1], ldcs))) : undefined), 0);
    }
    else {
        return 0;
    }
}

/**
 * The clock cycle a waveform simulation should start at, given what its expanded design will cost
 * in heap and what it was configured for.
 * 
 * A big design costs minutes to start, not seconds: main6 of the largeTest project is 480,000
 * components, and at the configured 2000 cycles it spent three minutes building 6GB of step
 * arrays and another two building 835,000 wave records - all before showing anything. Started
 * short it is seconds, and the configuration is still there to raise once the user has seen the
 * design work. This only ever lowers what was asked for.
 * 
 * Only the UNTOUCHED DEFAULT of a design past bigDesignHeapShare is lowered: a value anyone has
 * set in the configuration dialog is honoured exactly, however big the design. The dialog
 * already refuses what will not fit in memory (FastCreate.maxLastClockFor), so an explicit
 * value is one the user has been told the cost of - and overriding it made the configuration a
 * lie: main6 of largeTest, configured to 4000 cycles well inside its stated limit, was silently
 * started at 200 with no way to raise it, since the dialog is closed to a running simulation.
 * The overwrite even outlived the session, because WSConfig is saved in the sheet.
 * (An earlier version also tapered the allowed cycles as 40/share below the threshold, which
 * capped a 350-component CPU at 75,000 of its configured 1,000,000 cycles.)
 */
export function startingLastClock(configured, heapEstimate) {
    const budget = SimulationBudget_maxHeapBytes();
    if ((((configured === Constants_defaultWSConfig.LastClock) && (heapEstimate > 0)) && (budget > 0)) && ((heapEstimate / budget) > Constants_bigDesignHeapShare)) {
        return min(configured, Constants_shortStartClock) | 0;
    }
    else {
        return configured | 0;
    }
}

/**
 * How many cycles of history the step simulator may build for a design costing this much, or
 * None when it may not be simulated at all.
 * 
 * The waveform simulator gets its bound from a configuration dialog that prices the design and
 * refuses a last clock that will not fit. The step simulator has no dialog - it just picks a
 * length - so the same budget has to bind on that one number. `wanted` is what it would like;
 * this lowers it to what the design can afford, and refuses below `minStepArraySize`, where
 * there is not enough past to step back through.
 * 
 * Measured against maxCyclesFor, which is the budget WITHOUT the runtime headroom
 * checkSimulationFits allows itself. Deliberately the stricter of the two: a size chosen here is
 * then certain to pass the build's own check, so this decides the outcome rather than moving a
 * refusal to somewhere that explains it worse.
 */
export function stepSimCycles(wanted, cost) {
    const matchValue = maxCyclesFor(cost) | 0;
    if (matchValue >= wanted) {
        return wanted;
    }
    else if (matchValue >= Constants_minStepArraySize) {
        return matchValue;
    }
    else {
        return undefined;
    }
}

export function simulateModel(localBuild, isWaveSim, simulatedSheet, simulationArraySize, openSheetCanvasState_, openSheetCanvasState__1, model) {
    let tupledArg;
    const openSheetCanvasState = [openSheetCanvasState_, openSheetCanvasState__1];
    const start = getTimeMs();
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        return instrumentInterval("MakeSimData", start, (tupledArg = openSheetCanvasState, prepareSimulationMemoized(localBuild, isWaveSim, simulationArraySize, project.OpenFileName, defaultArg(simulatedSheet, project.OpenFileName), tupledArg[0], tupledArg[1], project.LoadedComponents)));
    }
    else {
        return [new FSharpResult$2(/* Error */ 1, [makeDummySimulationError("What - Internal Simulation Error starting simulation - I don\'t think this can happen!")]), openSheetCanvasState];
    }
}

/**
 * The design with one sheet's canvas replaced by the state given, and every other sheet as the
 * project holds it.
 * 
 * Which sheet is a parameter because saving names it: a save writes the canvas of the sheet being
 * saved, and until it finishes the project's own copy of that sheet is the version BEFORE the
 * edit. Walking the stale copy is how a component renamed on the canvas would be saved under the
 * name it no longer has.
 * The whole list goes in, INCLUDING the sheet being replaced: addStateToLoadedComponents replaces
 * it itself, and everything about the sheet that its canvas does not say - its parameters, whether
 * it is the top sheet, and whether it is an array component - it can only carry forward from the
 * copy already there. Filtering first left an array component looking like an ordinary sheet for
 * as long as it was the sheet being edited, so its ports came out wrong and it was never expanded.
 */
export function designWithSheet(project, sheet, canvasState_, canvasState__1) {
    const canvasState = [canvasState_, canvasState__1];
    return addStateToLoadedComponents(sheet, canvasState[0], canvasState[1], project.LoadedComponents);
}

/**
 * The design as the simulator sees it: the open sheet as it is on the canvas now, and every other
 * sheet as the project holds it. The same list prepareSimulationMemoized compares against, so a
 * verdict and a simulation go stale together.
 * 
 * canvasState is passed in rather than taken from model.Sheet: extracting it walks every symbol
 * and wire on the sheet, and the caller that runs per render already holds the one MainView
 * extracted for this frame.
 */
export function designOf(project, canvasState_, canvasState__1) {
    const canvasState = [canvasState_, canvasState__1];
    return designWithSheet(project, project.OpenFileName, canvasState[0], canvasState[1]);
}

function designIsUnchanged(ldcs1, ldcs2) {
    if (length(ldcs1) === length(ldcs2)) {
        return forAll((ldc) => {
            let option_1;
            return equals(true, (option_1 = tryFind((ldc$0027) => (ldc$0027.Name === ldc.Name), ldcs2), (option_1 != null) ? loadedComponentIsEqual(ldc, option_1) : undefined));
        }, ldcs1);
    }
    else {
        return false;
    }
}

/**
 * Should the Simulation tab ask for a new verdict? True when the stored one is missing or no
 * longer describes the design, and no check is already on its way.
 * 
 * The CheckPending test comes first, and not only to save the comparison: this is asked while
 * rendering, and a render that asked again for a check already scheduled would be answered with
 * another render, and so on without ever reaching the check.
 */
export function circuitCheckIsNeeded(model, canvasState_, canvasState__1) {
    const canvasState = [canvasState_, canvasState__1];
    if (model.CircuitCheck.CheckPending) {
        return false;
    }
    else {
        const matchValue = model.CircuitCheck.Verdict;
        const matchValue_1 = model.CurrentProj;
        let matchResult, checkedLdcs, project;
        if (matchValue != null) {
            if (matchValue_1 == null) {
                matchResult = 2;
            }
            else {
                matchResult = 0;
                checkedLdcs = matchValue[1];
                project = matchValue_1;
            }
        }
        else if (matchValue_1 == null) {
            matchResult = 2;
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return !designIsUnchanged(checkedLdcs, designOf(project, canvasState[0], canvasState[1]));
            case 1:
                return true;
            default:
                return false;
        }
    }
}

/**
 * Work out whether the open design builds into a simulation, and whether it is synchronous.
 * Called from the update function on a delay, never while rendering.
 */
export function runCircuitCheck(model) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        let ldcs;
        const tupledArg = DrawModelType_SheetT_Model__Model_GetCanvasState(model.Sheet);
        ldcs = designOf(project, tupledArg[0], tupledArg[1]);
        return new CircuitCheck([(() => {
            try {
                return Result_Map(hasSynchronousComponents, validateSheetOfDesign(project.OpenFileName, ldcs));
            }
            catch (e) {
                error(concat("exception while checking the circuit: ", e.message));
                return new FSharpResult$2(/* Error */ 1, [new SimulationError(new SimulationErrorType(/* InternalError */ 19, [e]), undefined, empty_1(), empty_1())]);
            }
        })(), ldcs], false);
    }
    else {
        return new CircuitCheck(undefined, false);
    }
}

let waveSimCostMemo = undefined;

/**
 * The per-cycle memory cost of wave-simulating the open design: what the waveform configuration
 * dialog's size message and its OK gating need, and nothing more.
 * 
 * This exists because the dialog used to get the same number by building a complete 10-cycle
 * simulation - every FastComponent, every step array - and reading one field off the result:
 * 49 seconds of frozen dialog on a 480,000-component design, and the waveform simulation cache
 * evicted on the way. The cost is a fact about the design's merged graph, so this stops there:
 * check the circuit, price its graph, allocate nothing - not even the flattening, which
 * stepCostOfGraph no longer needs.
 * The per-cycle cost of one sheet of the open design. `waveSimStepCost` below is this for the
 * sheet the waveform simulator is on; the step simulator asks for the open one, to decide how
 * many cycles of history it can afford (SimulationView.stepSimArraySize).
 * 
 * One memo entry, keyed by sheet: two callers asking about different sheets re-price rather than
 * share, which costs a graph walk. That is the right trade - the dialog asks per keystroke about
 * one sheet, and the step simulator asks once per build.
 */
export function designStepCost(model, simSheet) {
    let memoSheet, memoLdcs;
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        let ldcs;
        const tupledArg = DrawModelType_SheetT_Model__Model_GetCanvasState(model.Sheet);
        ldcs = designOf(project, tupledArg[0], tupledArg[1]);
        let matchResult, memoLdcs_1, memoSheet_1, result_1;
        if (waveSimCostMemo != null) {
            if ((waveSimCostMemo[2], (memoSheet = waveSimCostMemo[0], (memoLdcs = waveSimCostMemo[1], (memoSheet === simSheet) && designIsUnchanged(memoLdcs, ldcs))))) {
                matchResult = 0;
                memoLdcs_1 = waveSimCostMemo[1];
                memoSheet_1 = waveSimCostMemo[0];
                result_1 = waveSimCostMemo[2];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return result_1;
            default: {
                let result_3;
                try {
                    result_3 = Result_Map(stepCostOfGraph, validateSheetOfDesign(simSheet, ldcs));
                }
                catch (e) {
                    result_3 = (new FSharpResult$2(/* Error */ 1, [makeDummySimulationError(concat("exception while pricing the design: ", e.message))]));
                }
                waveSimCostMemo = [simSheet, ldcs, result_3];
                return result_3;
            }
        }
    }
    else {
        return new FSharpResult$2(/* Error */ 1, [makeDummySimulationError("No project is open")]);
    }
}

export function waveSimStepCost(model) {
    let matchValue_1, s_1;
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        return designStepCost(model, (matchValue_1 = model.WaveSimSheet, (matchValue_1 != null) ? ((matchValue_1 !== "") ? ((s_1 = matchValue_1, s_1)) : project.OpenFileName) : project.OpenFileName));
    }
    else {
        return new FSharpResult$2(/* Error */ 1, [makeDummySimulationError("No project is open")]);
    }
}

function symbolInspection(sym) {
    const comp = sym.Component;
    const Type = toString(comp.Type);
    const HScale = defaultArg(sym.HScale, 1);
    const VScale = defaultArg(sym.VScale, 1);
    const Rotation = toString(sym.STransform.Rotation);
    return {
        Flipped: sym.STransform.flipped,
        H: comp.H,
        HScale: HScale,
        Id: sym.Id,
        IsAnnotation: sym.Annotation != null,
        IsClocked: sym.IsClocked,
        Label: comp.Label,
        Ports: map_2((tupledArg) => ({
            Edge: toString(tupledArg[1]),
            Id: tupledArg[0],
        }), toArray(sym.PortMaps.Orientation)),
        Rotation: Rotation,
        Type: Type,
        VScale: VScale,
        W: comp.W,
        X: sym.Pos.X,
        Y: sym.Pos.Y,
    };
}

function wireInspection(wire) {
    return {
        FromPort: wire.OutputPort,
        Id: wire.WId,
        InitialOrientation: wire.InitialOrientation,
        Segments: toArray_1(map_1((aSeg) => ({
            Draggable: aSeg.Segment.Draggable,
            EndX: aSeg.End.X,
            EndY: aSeg.End.Y,
            Index: aSeg.Segment.Index,
            Mode: aSeg.Segment.Mode,
            StartX: aSeg.Start.X,
            StartY: aSeg.Start.Y,
        }), getAbsSegments(wire))),
        ToPort: wire.InputPort,
        Width: wire.Width,
    };
}

/**
 * Everything the draw block is showing on the open sheet, as data. Computed on demand, not on
 * every render: MainView publishes a function that calls this.
 */
export function canvasInspection(model) {
    let option_1;
    const sheet = model.Sheet;
    const Sheet = defaultArg((option_1 = model.CurrentProj, (option_1 != null) ? option_1.OpenFileName : undefined), "");
    return {
        ScrollX: sheet.ScreenScrollPos.X,
        ScrollY: sheet.ScreenScrollPos.Y,
        Selected: toArray_1(map_1((_arg) => _arg, sheet.SelectedComponents)),
        Sheet: Sheet,
        Symbols: map_2((arg) => symbolInspection(arg[1]), toArray(sheet.Wire.Symbol.Symbols)),
        Wires: map_2((arg_1) => wireInspection(arg_1[1]), toArray(sheet.Wire.Wires)),
        Zoom: sheet.Zoom,
    };
}

function RawDump_ofDrawBlock(wire) {
    return Convert_serialize(wire, createTypeInfo(DrawModelType_BusWireT_Model_$reflection()));
}

/**
 * The complete drawing state, serialised with the same library that writes .dgm files.
 * 
 * SimpleJson round-trips F# maps - including the ones keyed by a record or a single-case DU,
 * which it writes as an array of [key, value] pairs rather than as a JSON object - along with
 * sets, options and bigints. So there is no need to reduce anything by hand: this is every
 * symbol, wire, port and port map exactly as the model holds it.
 * 
 * BusWireT.Model is the largest part of the model that contains no functions at all. SheetT.Model
 * above it holds PopupViewFunc and a ChildProcess, and its undo and redo lists are whole models,
 * which would multiply the dump by the undo depth.
 * 
 * Returns a message rather than throwing if serialisation fails, so that a type SimpleJson cannot
 * represent degrades to a readable error instead of breaking the caller. Fable only: SimpleJson's
 * reflection does not work under .NET, which does not matter for renderer debug code.
 */
export function canvasRaw(model) {
    try {
        return RawDump_ofDrawBlock(model.Sheet.Wire);
    }
    catch (e) {
        return concat("{\"error\": \"serialisation failed: ", e.message, "\"}");
    }
}

